import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import BadgeImage from "../../../components/badges_image/badgesImage";

// Style constants
const borderColor = "#CCCCCC";

const TableWrapper = styled(Paper)({
  borderRadius: 16,
  backgroundColor: "#fff",
  overflow: "hidden",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15)",
});

const StyledTable = styled(Table)({
  borderCollapse: "separate",
  borderSpacing: 0,
});

const HeaderCell = styled(TableCell)({
  backgroundColor: "var(--org-bg-color, #f6615f)",
  color: "#fff",
  fontWeight: "bold",
  fontSize: 16,
  textAlign: "center",
  border: `1px solid ${borderColor}`,
  padding: "20px",
});

const StyledTableCell = styled(TableCell)(
  ({ isLastRow, isLastCol, isFirstCol, isFirstRow }) => ({
    backgroundColor: "#fff",
    color: "#000",
    fontSize: 16,
    textAlign: "center",
    padding: "10px 16px",
    borderBottom: !isLastRow ? `1px solid ${borderColor}` : "none",
    borderRight: !isLastCol ? `1px solid ${borderColor}` : "none",
    borderLeft: isFirstCol ? "none" : undefined,
    borderTop: isFirstRow ? "none" : undefined,
    height: isFirstRow && "100px",
  })
);

const BadgeRequirementsTable = ({ columns, rows, loading }) => {
  return (
    <TableWrapper className="mb-4">
      <StyledTable>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <HeaderCell key={col.id}>{col.label}</HeaderCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={columns.length}>
                <Box
                  height="64vh"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <div className="spinner-border text-danger" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </Box>
              </TableCell>
            </TableRow>
          ) : rows.map((row, rowIdx) => {
            const isLastRow = rowIdx === rows.length - 1;
            const isFirstRow = rowIdx === 0;
            return (
              <TableRow key={rowIdx}>
                {columns.map((col) => {
                  const value = row[col.id];

                  if (col.id === "badgeImage") {
                    return (
                      <StyledTableCell key={col.id} isLastRow={isLastRow}>
                        <BadgeImage
                          width={100}
                          height={100}
                          badgeName={(row.badgeName || "default").toLowerCase()}
                          altText={row.badgeName || "Default Badge"}
                        />
                      </StyledTableCell>
                    );
                  }

                  if (col.id === "badgeName") {
                    return (
                      <StyledTableCell key={col.id} isLastRow={isLastRow}>
                        <Typography sx={{ textTransform: "capitalize" }}>
                          {value}
                        </Typography>
                      </StyledTableCell>
                    );
                  }

                  if (col.id === "range") {
                    return (
                      <StyledTableCell key={col.id} isLastRow={isLastRow}>
                        {value.minPoints}
                        {`${value.maxPoints === null
                          ? "+Max "
                          : `- ${value.maxPoints}`
                          }`}{" "}
                        Points
                      </StyledTableCell>
                    );
                  }

                  return (
                    <StyledTableCell
                      key={col.id}
                      isLastRow={isLastRow}
                      isFirstRow={isFirstRow}
                    >
                      {value}
                    </StyledTableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </StyledTable>
    </TableWrapper>
  );
};

export default BadgeRequirementsTable;
